/* ==========================================================================
 * bb-paneelhulp.js - het scherm van de paneelhulp
 * --------------------------------------------------------------------------
 * De klant tekent zijn dak na. Per vlak: de maten van zijn paneel, hoeveel
 * panelen er naast elkaar liggen, liggend of staand, en welke randen dicht
 * moeten. Er tekent live een svg mee. Daarna kiest hij zijn marge en zijn
 * diameter, en rolt het voordeligste rollenpakket eruit.
 *
 * WAT HIER NIET IN ZIT
 * Geen enkele rekenregel. Alles wat rekent staat in bb-kern.js (window.BBKern),
 * dat regel voor regel uit rekentools/kern.js komt en over duizenden gevallen
 * naast de live WooCommerce-code is gelegd. Alles wat met de winkel praat staat
 * in bb-winkelwagen.js (window.BBWinkel). Dit bestand zet die twee aan het werk
 * en schrijft de tekst op het scherm.
 *
 * Die twee bestanden staan in thema/gedeeld/assets/ en worden ook door de
 * keuzehulp gebruikt. In het thema landen ze gewoon in assets/, dus aan de
 * scriptregels in sections/bb-paneelhulp.liquid verandert er niets.
 *
 * DE NEDERLANDSE TEKSTEN
 * Woord voor woord overgenomen uit bb-paneelhulp.php zoals die op
 * birdblocker.dealdonkeyadmin.nl/panelen-meten/ draait. Er zijn drie plekken
 * met nieuwe tekst, en alledrie omdat WooCommerce daar iets deed wat Shopify
 * niet kent: de meldingen rond de winkelwagenknop. Ze staan bij elkaar in
 * TEKST_WINKELWAGEN, zodat ze in een oogopslag te herkennen zijn.
 *
 * DE TEKENING
 * Gewone inline svg, geen bibliotheek, precies zoals de huidige tool het doet.
 * tekening() raakt het scherm niet aan en leest niets uit de pagina: hij krijgt
 * een lijst vlakken binnen en geeft een stuk svg terug. Daardoor is hij in
 * test/paneelhulp.test.mjs los na te rekenen, zonder browser.
 *
 * PRE-ORDER (16-09, nacht-16-09/pre-order-contract.md)
 * De rekenkern kent geen voorraadaantallen. Een pakket van 100 rollen ging dus
 * vrolijk naar Shopify, kreeg een 422 en de klant las alleen dat het mislukt
 * was. De voorraadcontrole zit daarom NAAST de kern, hier, met
 * window.BSPreorder (snippets/bs-preorder.liquid). Past het pakket niet, dan
 * komt op de plek van de koopknop melding M5 met de knop "Pre-order
 * aanvragen"; is de hele diameter op, dan M6. Staat BSPreorder niet op de
 * pagina, dan verandert er niets aan het scherm.
 *
 * MEER DAN 50 VAN EEN MAAT (16-09, gemeten)
 * /cart/add.js kapt in de items[]-vorm elke regel af op 50 stuks, ook bij 871
 * op voorraad. Een pakket van 73 rollen kwam daardoor als 50 in de winkelwagen
 * terecht. Zie pakketInWagen(): binnen de 50 blijft alles precies zoals het
 * was, daarboven gaat de regel via de enkele vorm {id, quantity}, die de grens
 * niet kent, en meten we in /cart.js na of de belofte op de knop is
 * waargemaakt.
 * ========================================================================== */
(function (global) {
	'use strict';

	var K = global.BBKern;
	var W = global.BBWinkel;

	/* Klantteksten uit window.BSTekst (snippets/bs-teksten.liquid, sleutels bs.* in de
	   locale-bestanden). Ontbreekt een tekst, of draait dit bestand in node, dan de
	   Nederlandse terugval die hier in de code staat. {naam} wordt ingevuld. */
	function tk(sleutel, terug, waarden) {
		var bron = global.BSTekst;
		var s = (bron && typeof bron[sleutel] === 'string' && bron[sleutel] !== '' && bron[sleutel].indexOf('translation missing') !== 0) ? bron[sleutel] : terug;
		if (!waarden) { return s; }
		return String(s).replace(/\{(\w+)\}/g, function (heel, naam) {
			return Object.prototype.hasOwnProperty.call(waarden, naam) ? String(waarden[naam]) : heel;
		});
	}

	/* Het woord achter een aantal panelen. Terugval: K.paneelWoord (bb-kern.js, ongewijzigd). */
	function paneelWoord(n) {
		return n === 1 ? tk('ph_paneel', K.paneelWoord(n)) : tk('ph_panelen', K.paneelWoord(n));
	}

	/* liggend/staand is ook een waarde in de rekenkern; alleen de weergave wordt vertaald. */
	function liggingTekst(l) {
		if (l === 'liggend') { return tk('ph_liggend', 'liggend'); }
		if (l === 'staand') { return tk('ph_staand', 'staand'); }
		return l;
	}

	/* ======================================================================
	 * INSTELLINGEN
	 * ----------------------------------------------------------------------
	 * Startwaarden in invulvelden, geen productgegevens. De klant ziet ze
	 * staan en overschrijft ze met de maat van zijn eigen paneel. 1,70 bij
	 * 1,10 m is de maat van een gangbaar zonnepaneel en is ook de aanname die
	 * de keuzehulp gebruikt, zodat de twee hulpen bij dezelfde invoer op
	 * hetzelfde getal uitkomen.
	 *
	 * In het thema komen ze uit het schema van sections/bb-paneelhulp.liquid,
	 * zodat Gio ze zonder code kan aanpassen. De waarden hieronder zijn de
	 * terugval als dat blok ontbreekt, en ze zijn gelijk aan de plugin.
	 * ==================================================================== */
	var STANDAARD = {
		lang: 170,          /* lange zijde in centimeters */
		kort: 110,          /* korte zijde in centimeters */
		aantal: 10,         /* panelen naast elkaar in een vlak */
		marge: 10,          /* procent speling */
		maxVlakken: 8,      /* bovengrenzen, puur tegen typefouten */
		maxPanelen: 200,
		maxMeters: 2000,
		/* DE PALLETREGEL STAAT UIT, EN DAT IS GEEN VERGISSING.
		   Een Shopify-thema kan de winkelwagentotalen niet aanpassen; daar is
		   een eigen app met een Shopify Function voor nodig. Zolang die er niet
		   is zou de kaart 5 procent beloven en de winkelwagen 0 procent rekenen.
		   Zet deze schakelaar dus pas aan als die korting echt in de
		   winkelwagen valt. */
		toonPalletregel: false,
		naToevoegen: 'winkelwagen',   /* 'winkelwagen' of 'blijf' */
		winkelwagenSecties: ''
	};

	/* De drie nieuwe teksten. WooCommerce handelde de knop server-side af en
	   toonde een WooCommerce-melding na een omleiding; op Shopify gebeurt alles
	   in de browser en moet de melding hier staan. */
	var TEKST_WINKELWAGEN = {
		bezig: tk('ph_bezig', 'Bezig met toevoegen...'),
		gelukt: tk('ph_gelukt', 'Gelukt, je pakket ligt in je winkelwagen.'),
		/* Shopify voegt bij een 422 NIETS toe, ook de regels die wel konden niet.
		   Die "alles of niets" moet in de melding staan, anders gaat de klant op
		   zoek naar de helft die er wel in zou liggen. */
		mislukt: tk('ph_mislukt', 'Er kon niets worden toegevoegd, ook de andere lengtes niet. Waarschijnlijk is een van deze rollen net uitverkocht. Probeer het opnieuw of leg de rollen los in je winkelwagen.'),
		/* Boven de 50 stuks gaat een regel apart naar Shopify (zie
		   pakketInWagen). Dan kan een deel wel lukken en een deel niet, en dat
		   moet er staan: anders zoekt de klant naar rollen die er niet liggen. */
		deels: tk('ph_deels', 'Een deel van het pakket ligt in je winkelwagen. Voor de rest was er niet genoeg voorraad. Kijk in je winkelwagen wat er ligt en vraag de rest aan als pre-order.'),
		verbinding: tk('ph_verbinding', 'Er ging iets mis met de verbinding. Probeer het nog een keer.')
	};

	/* ======================================================================
	 * KLEINE HULPJES, GELIJK AAN DE KEUZEHULP
	 * ==================================================================== */

	function esc(t) {
		return String(t === null || t === undefined ? '' : t)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}

	/* ----------------------------------------------------------------------
	 * GELD OP HET SCHERM (bevindingen K2 en K6, gemeten 16-09)
	 * ----------------------------------------------------------------------
	 * Hier stond K.euroUitCenten(). Dat geeft platte tekst, en dat gaf twee
	 * fouten:
	 *   K2  het bedrag luisterde NIET naar de btw-schakelaar. In de stand
	 *       "excl. btw" beloofde de uitslagkaart EUR 79,98 terwijl de
	 *       winkelwagen op datzelfde moment EUR 66,10 toonde: 21% te hoog,
	 *       precies het getal waarop de klant klikt.
	 *   K6  geen duizendtalpunt: "EUR 2934,26" terwijl de keuzehulp en de
	 *       winkelwagen "EUR 2.934,41" schrijven.
	 * De keuzehulp doet het al goed en gebruikt window.BSBtw.prijsHtml, net als
	 * snippets/bs-prijs.liquid: BEIDE bedragen staan in de HTML en CSS toont er
	 * een op grond van <html data-btw>. Dat is hier overgenomen.
	 * bs-btw.js staat met defer in de head van theme.liquid en is dus altijd
	 * eerder geladen dan dit bestand; de terugval hieronder is er alleen voor
	 * een pagina zonder dat bestand.
	 * bb-kern.js blijft ongemoeid (verboden bestand).
	 *
	 * LET OP: dit geeft HTML terug. Niet door esc() halen.
	 * De opmaak (letter en kleur van de plek zelf) komt uit
	 * assets/bb-paneelhulp.css: .bb-ph .bs-prijs { font: inherit }.
	 * -------------------------------------------------------------------- */
	function prijs(centen, opties) {
		var c = Math.round(Number(centen) || 0);
		var B = global.BSBtw;
		if (B && typeof B.prijsHtml === 'function') { return B.prijsHtml(c, opties || {}); }
		return esc(K.euroUitCenten(c));
	}

	function exclCenten(centen) {
		var B = global.BSBtw;
		if (B && typeof B.exclCenten === 'function') { return B.exclCenten(centen); }
		return Math.round(Number(centen) * 100 / 121);
	}

	/* Zelfde HTML als prijs(), maar met een ZELF MEEGEGEVEN excl.-bedrag.
	   Nodig voor het totaal van de kaart: in de excl.-stand moet dat de SOM van
	   de afgeronde regels zijn, niet een eigen afronding van het totaal.
	   Anders staat er een cent minder dan de regels erboven optellen, en een
	   cent minder dan de winkelwagen straks toont (bevinding K5; dezelfde
	   reparatie staat in sections/main-cart-footer.liquid en in bb-keuzehulp.js).
	   Het te betalen bedrag (incl. btw) verandert hier niet. */
	function prijsTwee(inclC, exclC, opties) {
		opties = opties || {};
		var B = global.BSBtw;
		if (!B || typeof B.bedrag !== 'function') { return prijs(inclC, opties); }
		var maat = (opties.maat === 'groot' || opties.maat === 'klein') ? opties.maat : 'normaal';
		return '<span class="bs-prijs bs-prijs--' + maat + '">'
			+ '<span class="bs-incl">' + B.bedrag(Math.round(Number(inclC) || 0)) + '</span>'
			+ '<span class="bs-excl">' + B.bedrag(Math.round(Number(exclC) || 0)) + '</span></span>';
	}
	function leesGetal(el) {
		if (!el) { return 0; }
		var n = parseFloat(String(el.value).replace(',', '.'));
		return isFinite(n) ? n : 0;
	}

	/* ======================================================================
	 * DE TEKENING
	 * ----------------------------------------------------------------------
	 * Gewone inline svg, geen bibliotheek. Alles staat in eenheden van het
	 * viewBox, dus de tekening schaalt in zijn geheel mee met de breedte van
	 * het scherm: op een telefoon van 375 px blijft de verhouding kloppen en
	 * hoeft er nooit horizontaal geschoven te worden.
	 *
	 * De bijschriften onder de tekening staan bewust NIET in de tekening maar
	 * er in gewone html onder. Tekst in een geschaald viewBox wordt op een
	 * telefoon onleesbaar klein; html-tekst niet.
	 * ==================================================================== */

	/** De vaste maten van het tekenvlak, in eenheden van het viewBox. */
	var TEKENING = {
		W: 1000,
		/* padT en tussen zijn ruimer dan de tekening zelf nodig heeft, en dat is
		   met opzet. Een rij van tientallen panelen wordt zo plat dat het
		   bijschrift er niet meer in past en boven het vlak komt te staan. Die
		   regel moet ergens kunnen staan, ook boven het eerste vlak en tussen
		   twee vlakken in. */
		padL: 74, padR: 26, padB: 26, padT: 52,
		tussen: 64,      /* ruimte tussen twee vlakken, in eenheden */
		maxH: 560,
		/* Onder deze hoogte past het bijschrift niet meer in het vlak en gaat
		   het erboven staan. Dat was de fout boven de 40 panelen: dan is een rij
		   maar een paar eenheden hoog en stond de tekst er dwars doorheen. */
		tekstPast: 40,
		/* Onder deze breedte per paneel wordt elk blokje een streepje en is de
		   tekening niet meer te lezen; dan tonen we het vlak als een geheel. */
		paneelLeesbaar: 9,
		maxLosgetekend: 40,
		wering: 9        /* de vogelwering wordt zoveel buiten het vlak getekend */
	};

	/**
	 * Bouwt de svg. Pure functie: geen dom, niets uit de pagina.
	 *
	 * @param {array} vlakken [{ lang, kort, aantal, ligging, randen }]
	 * @returns {string} html
	 */
	function tekening(vlakken) {
		var T = TEKENING;
		var bruikbaar = (vlakken || []).filter(K.vlakGeldig);
		if (!bruikbaar.length) {
			return '<p class="bb-ph-grijs">' + tk('ph_tekening_leeg', 'Zodra je de maten invult, verschijnt hier je indeling.') + '</p>';
		}

		var breedstOnvertaald = 0, hoogteSom = 0;
		bruikbaar.forEach(function (g) {
			var b = K.rijBreedte(g);
			if (b > breedstOnvertaald) { breedstOnvertaald = b; }
			hoogteSom += K.rijHoogte(g);
		});
		if (breedstOnvertaald <= 0 || hoogteSom <= 0) { return ''; }

		var ruimteH = T.maxH - T.padT - T.padB - T.tussen * (bruikbaar.length - 1);
		var schaalB = (T.W - T.padL - T.padR) / breedstOnvertaald;
		var schaalH = ruimteH > 0 ? (ruimteH / hoogteSom) : schaalB;
		var schaal = Math.min(schaalB, schaalH);

		var H = T.padT + T.padB + hoogteSom * schaal + T.tussen * (bruikbaar.length - 1);

		var s = '<svg class="bb-ph-svg" viewBox="0 0 ' + T.W + ' ' + Math.round(H) + '" role="img" '
			+ 'aria-label="' + esc(tk('ph_tekening_label', 'Tekening van je indeling met de af te dichten randen gemarkeerd')) + '">';

		var y = T.padT;
		bruikbaar.forEach(function (g, i) {
			var b = K.rijBreedte(g) * schaal;
			var h = K.rijHoogte(g) * schaal;
			var x = T.padL;

			// Het nummer van het vlak, links naast de rij.
			s += '<circle class="badge" cx="' + (T.padL - 38) + '" cy="' + (y + h / 2) + '" r="20"></circle>';
			s += '<text class="badgetekst" x="' + (T.padL - 38) + '" y="' + (y + h / 2 + 10) + '" text-anchor="middle">' + (i + 1) + '</text>';

			// De panelen. Zijn het er heel veel, dan wordt elk blokje een streepje
			// en is de tekening niet meer te lezen; dan tonen we het vlak als een
			// geheel met het aantal erin.
			var perPaneel = b / g.aantal;
			if (g.aantal <= T.maxLosgetekend && perPaneel >= T.paneelLeesbaar) {
				for (var k = 0; k < g.aantal; k++) {
					s += '<rect class="paneel" x="' + (x + k * perPaneel + 1.5) + '" y="' + (y + 1.5) + '" '
						+ 'width="' + Math.max(1, perPaneel - 3) + '" height="' + Math.max(1, h - 3) + '" rx="2"></rect>';
				}
			} else {
				s += '<rect class="paneel" x="' + x + '" y="' + y + '" width="' + b + '" height="' + h + '" rx="3"></rect>';
				/* Past het bijschrift in het vlak, dan staat het erin. Een rij van
				   veel panelen is maar een paar eenheden hoog terwijl de letter er
				   30 nodig heeft; dan gaat de regel BOVEN het vlak staan in plaats
				   van er dwars doorheen. Dit is de reparatie die de tekening boven
				   de 40 panelen weer leesbaar maakte, en die moest hier mee. */
				if (h >= T.tekstPast) {
					s += '<text class="blokTekst" x="' + (x + b / 2) + '" y="' + (y + h / 2 + 10) + '" text-anchor="middle">'
						+ g.aantal + ' ' + esc(paneelWoord(g.aantal)) + '</text>';
				} else {
					s += '<text class="blokTekst buiten" x="' + (x + b / 2) + '" y="' + (y - 20) + '" text-anchor="middle">'
						+ g.aantal + ' ' + esc(paneelWoord(g.aantal)) + '</text>';
				}
			}

			// De vogelwering, net buiten het vlak zodat de rand van de panelen
			// zichtbaar blijft.
			var o = T.wering;
			if (g.randen === 'omtrek') {
				s += '<rect class="wering" x="' + (x - o) + '" y="' + (y - o) + '" width="' + (b + 2 * o) + '" height="' + (h + 2 * o) + '" rx="5"></rect>';
			} else {
				s += '<line class="wering" x1="' + (x - o) + '" y1="' + (y + h + o) + '" x2="' + (x + b + o) + '" y2="' + (y + h + o) + '"></line>';
				if (g.randen === 'onderboven') {
					s += '<line class="wering" x1="' + (x - o) + '" y1="' + (y - o) + '" x2="' + (x + b + o) + '" y2="' + (y - o) + '"></line>';
				}
			}

			y += h + T.tussen;
		});

		s += '</svg>';
		return s;
	}

	/* ======================================================================
	 * HET SCHERM
	 * ==================================================================== */

	function start(wortelEl, G, instellingen) {
		var I = {};
		Object.keys(STANDAARD).forEach(function (n) { I[n] = STANDAARD[n]; });
		Object.keys(instellingen || {}).forEach(function (n) {
			if (instellingen[n] !== null && instellingen[n] !== undefined && instellingen[n] !== '') {
				I[n] = instellingen[n];
			}
		});

		var vGroepen  = wortelEl.querySelector('#bb-ph-groepen');
		var vTekening = wortelEl.querySelector('#bb-ph-tekening');
		var vSubtot   = wortelEl.querySelector('#bb-ph-subtotaal');
		var vErbij    = wortelEl.querySelector('#bb-ph-erbij');
		var vStap2    = wortelEl.querySelector('#bb-ph-stap2');
		var vStap3    = wortelEl.querySelector('#bb-ph-stap3');
		var vUitslag  = wortelEl.querySelector('#bb-ph-uitslag');
		if (!vGroepen || !vTekening || !vSubtot || !vErbij || !vStap2 || !vStap3 || !vUitslag) { return null; }

		var groepen = [];
		var marge   = { soort: 'procent', procent: I.marge, meters: 0 };
		var keuze   = { diameter: 0 };
		var laatstePakket = null;

		/* Pre-order: de winkelwagen wordt hier alleen gelezen om te weten
		   hoeveel er van een maat al in ligt. De palletregel staat uit, dus
		   haalWinkelwagen() doet niets; dit is een eigen, lichte lezing die pas
		   loopt zodra de klant echt een pakket te zien krijgt. */
		var poWagen = null;
		var poWagenGevraagd = false;
		var poVrij = null;
		var poOpen = null;      /* opties voor BSPreorder.open bij een pakket met regels */

		/* ---------- stap 1: de vlakken ---------- */

		function nieuwVlak() {
			return {
				lang: I.lang,
				kort: I.kort,
				aantal: I.aantal,
				ligging: 'liggend',
				randen: 'onder'
			};
		}

		function groepKaart(g, i) {
			var n = i + 1;
			var h = '<div class="bb-ph-groep" data-i="' + i + '">';
			h += '<div class="bb-ph-groepkop"><span class="bb-ph-nummer">' + n + '</span> ' + tk('ph_vlak', 'Vlak {n}', { n: n });
			if (i > 0) {
				h += '<button type="button" class="bb-ph-weg" data-weg="' + i + '" aria-label="' + esc(tk('ph_vlak_weg', 'Vlak {n} verwijderen', { n: n })) + '">' + tk('verwijderen', 'Verwijderen') + '</button>';
			}
			h += '</div>';

			h += '<div class="bb-ph-velden">'
				+ '<label class="bb-ph-veld"><span>' + tk('ph_lang', 'Lange zijde paneel (cm)') + '</span>'
				+ '<input type="number" id="bb-ph-lang-' + i + '" min="20" max="400" step="1" inputmode="decimal" value="' + esc(g.lang) + '"></label>'
				+ '<label class="bb-ph-veld"><span>' + tk('ph_kort', 'Korte zijde paneel (cm)') + '</span>'
				+ '<input type="number" id="bb-ph-kort-' + i + '" min="20" max="400" step="1" inputmode="decimal" value="' + esc(g.kort) + '"></label>'
				+ '<label class="bb-ph-veld"><span>' + tk('ph_naast', 'Panelen naast elkaar') + '</span>'
				+ '<input type="number" id="bb-ph-aantal-' + i + '" min="1" max="' + I.maxPanelen + '" step="1" inputmode="numeric" value="' + esc(g.aantal) + '"></label>'
				+ '</div>';

			h += '<p class="bb-ph-vraagje">' + tk('ph_hoe_liggen', 'Hoe liggen de panelen in dit vlak?') + '</p>'
				+ '<div class="bb-ph-radios">'
				+ '<label><input type="radio" name="bb-ph-lig-' + i + '" value="liggend"' + (g.ligging === 'liggend' ? ' checked' : '') + '> <span>' + tk('ph_liggend_uitleg', '<b>Liggend</b>, de lange zijde horizontaal') + '</span></label>'
				+ '<label><input type="radio" name="bb-ph-lig-' + i + '" value="staand"' + (g.ligging === 'staand' ? ' checked' : '') + '> <span>' + tk('ph_staand_uitleg', '<b>Staand</b>, de lange zijde rechtop') + '</span></label>'
				+ '</div>';

			h += '<p class="bb-ph-vraagje">' + tk('ph_welke_randen', 'Welke randen dicht je af?') + '</p>'
				+ '<div class="bb-ph-radios kolom">'
				+ '<label><input type="radio" name="bb-ph-rand-' + i + '" value="onder"' + (g.randen === 'onder' ? ' checked' : '') + '> <span>' + tk('ph_rand_onder_uitleg', 'Alleen de <b>onderzijde</b> <em>(vogels kruipen van onderaf onder je panelen. Ligt je bovenkant tegen de nok, dan is dit meestal genoeg)</em>') + '</span></label>'
				+ '<label><input type="radio" name="bb-ph-rand-' + i + '" value="onderboven"' + (g.randen === 'onderboven' ? ' checked' : '') + '> <span>' + tk('ph_rand_onderboven_uitleg', '<b>Onder en boven</b>') + '</span></label>'
				+ '<label><input type="radio" name="bb-ph-rand-' + i + '" value="omtrek"' + (g.randen === 'omtrek' ? ' checked' : '') + '> <span>' + tk('ph_rand_omtrek_uitleg', 'De <b>hele omtrek</b>, ook de zijkanten') + '</span></label>'
				+ '</div>';

			h += '<div class="bb-ph-groepsom" id="bb-ph-som-' + i + '"></div>';
			h += '</div>';
			return h;
		}

		function koppel(i) {
			var g = groepen[i];

			['lang', 'kort', 'aantal'].forEach(function (naam) {
				var el = wortelEl.querySelector('#bb-ph-' + naam + '-' + i);
				if (!el) { return; }
				el.addEventListener('input', function () {
					var n = leesGetal(el);
					if (naam === 'aantal') {
						n = Math.floor(n);
						if (n > I.maxPanelen) { n = I.maxPanelen; el.value = String(n); }
					}
					if (n < 0) { n = 0; }
					g[naam] = n;
					ververs();
				});
			});

			Array.prototype.forEach.call(wortelEl.querySelectorAll('[name="bb-ph-lig-' + i + '"]'), function (el) {
				el.addEventListener('change', function () { g.ligging = el.value; ververs(); });
			});
			Array.prototype.forEach.call(wortelEl.querySelectorAll('[name="bb-ph-rand-' + i + '"]'), function (el) {
				el.addEventListener('change', function () { g.randen = el.value; ververs(); });
			});

			var weg = vGroepen.querySelector('[data-weg="' + i + '"]');
			if (weg) {
				weg.addEventListener('click', function () {
					groepen.splice(i, 1);
					tekenGroepen();
				});
			}
		}

		function tekenGroepen() {
			var h = '';
			groepen.forEach(function (g, i) { h += groepKaart(g, i); });
			vGroepen.innerHTML = h;
			groepen.forEach(function (g, i) { koppel(i); });
			vErbij.disabled = groepen.length >= I.maxVlakken;
			vErbij.textContent = groepen.length >= I.maxVlakken
				? tk('ph_meer_vlakken', 'Meer dan {max} vlakken? Neem even contact op', { max: I.maxVlakken })
				: tk('ph_vlak_erbij', '+ Nog een vlak toevoegen');
			ververs();
		}

		function randTekst(g) {
			if (g.randen === 'omtrek') { return tk('ph_rand_omtrek', 'hele omtrek'); }
			if (g.randen === 'onderboven') { return tk('ph_rand_onderboven', 'onder en boven'); }
			return tk('ph_rand_onder', 'alleen onderzijde');
		}

		/* De rekensom per vlak, zo opgeschreven dat de klant hem met een
		   rekenmachine kan nalopen. */
		function groepSom(g) {
			var b = K.rijBreedte(g);
			var h = K.rijHoogte(g);
			var perPaneel = g.ligging === 'staand' ? K.vlakKort(g) : K.vlakLang(g);
			var som = tk('ph_som', '{panelen} × {per} = {breed} breed, {hoog} hoog', { panelen: g.aantal + ' ' + paneelWoord(g.aantal), per: K.meterTekst(perPaneel), breed: K.meterTekst(b), hoog: K.meterTekst(h) });

			if (g.randen === 'omtrek') {
				return som + '<br>' + tk('ph_som_omtrek', 'hele omtrek: 2 × ({breed} + {hoog}) = <b>{m}</b>', { breed: K.meterTekst(b), hoog: K.meterTekst(h), m: K.meterTekst(K.vlakMeters(g)) });
			}
			if (g.randen === 'onderboven') {
				return som + '<br>' + tk('ph_som_onderboven', 'onder en boven: 2 × {breed} = <b>{m}</b>', { breed: K.meterTekst(b), m: K.meterTekst(K.vlakMeters(g)) });
			}
			return som + '<br>' + tk('ph_som_onder', 'alleen de onderzijde: <b>{m}</b>', { m: K.meterTekst(K.vlakMeters(g)) });
		}

		function ververs() {
			groepen.forEach(function (g, i) {
				var vak = wortelEl.querySelector('#bb-ph-som-' + i);
				if (!vak) { return; }
				vak.innerHTML = K.vlakGeldig(g)
					? groepSom(g)
					: '<span class="bb-ph-grijs">' + tk('ph_vlak_ongeldig', 'Vul de maten van je paneel en het aantal panelen in, anders telt dit vlak niet mee.') + '</span>';
			});

			vTekening.innerHTML = tekening(groepen);

			var kaal = K.totaalKaal(groepen);
			if (kaal > 0) {
				var regels = '';
				groepen.forEach(function (g, i) {
					if (!K.vlakGeldig(g)) { return; }
					regels += '<li><span>' + tk('ph_regel', 'Vlak {n}: {panelen} {ligging}, {randen}', { n: i + 1, panelen: g.aantal + ' ' + paneelWoord(g.aantal), ligging: esc(liggingTekst(g.ligging)), randen: esc(randTekst(g)) }) + '</span>'
						+ '<b>' + esc(K.meterTekst(K.vlakMeters(g))) + '</b></li>';
				});
				vSubtot.innerHTML = '<ul class="bb-ph-lijst">' + regels
					+ '<li class="totaal"><span>' + tk('ph_samen_zonder', 'Samen, nog zonder marge') + '</span><b>' + esc(K.meterTekst(kaal)) + '</b></li></ul>';
			} else {
				vSubtot.innerHTML = '';
			}

			// Staat de uitslag al op het scherm, dan schuift die gewoon mee.
			if (keuze.diameter > 0 && kaal > 0) { toonUitslag(); }
		}

		/* ---------- schermopbouw, zelfde manier als de keuzehulp ---------- */

		function toon(vak, html) { vak.innerHTML = html; vak.hidden = false; }
		function verberg(vak) { vak.innerHTML = ''; vak.hidden = true; }
		function naar(vak) {
			if (vak && vak.scrollIntoView) { vak.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
		}
		function fout(vakId, tekst) {
			var f = wortelEl.querySelector('#' + vakId);
			if (f) { f.innerHTML = tekst ? '<span class="bb-ph-fout" role="alert">' + esc(tekst) + '</span>' : ''; }
		}
		function tegelsAan(vak, opKeuze) {
			Array.prototype.forEach.call(vak.querySelectorAll('.bb-ph-tegel'), function (knop) {
				knop.addEventListener('click', function () {
					Array.prototype.forEach.call(vak.querySelectorAll('.bb-ph-tegel'), function (x) {
						x.classList.remove('sel');
						x.setAttribute('aria-pressed', 'false');
					});
					knop.classList.add('sel');
					knop.setAttribute('aria-pressed', 'true');
					opKeuze(knop);
				});
			});
		}

		vErbij.addEventListener('click', function () {
			if (groepen.length >= I.maxVlakken) { return; }
			groepen.push(nieuwVlak());
			tekenGroepen();
			var laatste = vGroepen.lastElementChild;
			if (laatste) { naar(laatste); }
		});

		wortelEl.querySelector('#bb-ph-naarstap2').addEventListener('click', function () {
			var kaal = K.totaalKaal(groepen);
			if (kaal <= 0) {
				fout('bb-ph-fout1', tk('ph_fout1', 'Vul eerst de maten van je paneel en het aantal panelen in.'));
				return;
			}
			fout('bb-ph-fout1', '');
			verberg(vStap3);
			vUitslag.innerHTML = '';
			keuze.diameter = 0;
			toonStap2();
		});

		/* ---------- stap 2: de marge ---------- */

		function toonStap2() {
			var h = '<p class="bb-ph-vraag">' + tk('ph_stap2', '2. Hoeveel speling wil je erbij?') + '</p>'
				+ '<p class="bb-ph-uitleg">' + tk('ph_stap2_uitleg', 'Een te lange rol buig je aan het uiteinde om, dus een beetje over is prettiger dan een halve meter te kort. '
				+ 'Kies zelf of je een vast aantal meters extra wilt of een percentage. Heb je scherp gemeten en wil je niets extra, zet hem dan op 0.') + '</p>'
				+ '<div class="bb-ph-radios kolom">'
				+ '<label><input type="radio" name="bb-ph-marge" value="procent"' + (marge.soort === 'procent' ? ' checked' : '') + '> <span>' + tk('ph_marge_procent', 'Een <b>percentage</b> van het totaal') + '</span></label>'
				+ '<label><input type="radio" name="bb-ph-marge" value="meters"' + (marge.soort === 'meters' ? ' checked' : '') + '> <span>' + tk('ph_marge_meters', 'Een vast aantal <b>extra meters</b>') + '</span></label>'
				+ '</div>'
				+ '<div class="bb-ph-velden">'
				+ '<label class="bb-ph-veld" id="bb-ph-veld-procent"><span>' + tk('ph_marge_label', 'Marge in procent') + '</span>'
				+ '<input type="number" id="bb-ph-procent" min="0" max="100" step="1" inputmode="decimal" value="' + esc(marge.procent) + '"></label>'
				+ '<label class="bb-ph-veld" id="bb-ph-veld-meters"><span>' + tk('ph_extra_meters', 'Extra meters') + '</span>'
				+ '<input type="number" id="bb-ph-extra" min="0" max="200" step="0.1" inputmode="decimal" value="' + esc(marge.meters) + '"></label>'
				+ '</div>'
				+ '<div id="bb-ph-margesom"></div>'
				+ '<p><button type="button" class="bb-ph-knop" id="bb-ph-naarstap3">' + tk('ph_volgende_stap', 'Volgende stap') + '</button></p>'
				+ '<div id="bb-ph-fout2"></div>';

			toon(vStap2, h);

			Array.prototype.forEach.call(wortelEl.querySelectorAll('[name="bb-ph-marge"]'), function (el) {
				el.addEventListener('change', function () { marge.soort = el.value; margeVerversen(); });
			});
			wortelEl.querySelector('#bb-ph-procent').addEventListener('input', function () {
				marge.procent = Math.max(0, leesGetal(this));
				margeVerversen();
			});
			wortelEl.querySelector('#bb-ph-extra').addEventListener('input', function () {
				marge.meters = Math.max(0, leesGetal(this));
				margeVerversen();
			});
			wortelEl.querySelector('#bb-ph-naarstap3').addEventListener('click', function () {
				var totaal = K.metMarge(K.totaalKaal(groepen), marge);
				if (totaal > I.maxMeters) {
					fout('bb-ph-fout2', tk('ph_teveel', 'Dat is meer dan {max} meter. Neem even contact op, dan maken wij een offerte op maat.', { max: I.maxMeters }));
					return;
				}
				fout('bb-ph-fout2', '');
				vUitslag.innerHTML = '';
				toonStap3();
			});

			margeVerversen();
			naar(vStap2);
		}

		function margeVerversen() {
			var procent = wortelEl.querySelector('#bb-ph-veld-procent');
			var meters = wortelEl.querySelector('#bb-ph-veld-meters');
			if (procent && meters) {
				procent.hidden = (marge.soort !== 'procent');
				meters.hidden = (marge.soort !== 'meters');
			}
			var vak = wortelEl.querySelector('#bb-ph-margesom');
			if (!vak) { return; }

			var kaal = K.totaalKaal(groepen);
			var totaal = K.metMarge(kaal, marge);
			var tekst;
			if (marge.soort === 'procent') {
				tekst = marge.procent > 0
					? K.meterTekst(kaal) + ' + ' + K.procentTekst(marge.procent) + '% = <b>' + K.meterTekst(totaal) + '</b>'
					: K.meterTekst(kaal) + ', ' + tk('ph_zonder_marge', 'zonder marge') + ' = <b>' + K.meterTekst(totaal) + '</b>';
			} else {
				tekst = marge.meters > 0
					? K.meterTekst(kaal) + ' + ' + K.meterTekst(marge.meters) + ' ' + tk('ph_extra', 'extra') + ' = <b>' + K.meterTekst(totaal) + '</b>'
					: K.meterTekst(kaal) + ', ' + tk('ph_zonder_marge', 'zonder marge') + ' = <b>' + K.meterTekst(totaal) + '</b>';
			}
			vak.innerHTML = '<div class="bb-ph-rekensom">' + tekst + '</div>';
		}

		/* ---------- stap 3: welke diameter ---------- */

		function toonStap3() {
			var ds = K.diameters(G.producten);
			var h = '<p class="bb-ph-vraag">' + tk('ph_stap3', '3. Welke diameter past onder jouw panelen?') + '</p>'
				+ '<div class="bb-ph-tegels" data-aantal="' + (ds.length + 1) + '" id="bb-ph-dtegels">';

			ds.forEach(function (d) {
				var lijst = K.vanDiameter(G.producten, d);
				var goedkoopstePerMeter = null;
				lijst.forEach(function (p) {
					var pm = p.centen / p.meters;
					if (goedkoopstePerMeter === null || pm < goedkoopstePerMeter) { goedkoopstePerMeter = pm; }
				});
				h += '<button type="button" class="bb-ph-tegel" data-diameter="' + d + '">'
					+ '<span class="ico">Ø' + d + '</span>'
					+ '<span class="kop">Ø ' + d + ' cm</span>'
					+ '<span class="sub">' + tk('ph_tegel_sub', 'Voor een opening tot {d} cm<br>vanaf {prijs} per meter', { d: d, prijs: prijs(Math.round(goedkoopstePerMeter)) }) + '</span>'
					+ '</button>';
			});
			h += '<button type="button" class="bb-ph-tegel" data-diameter="0">'
				+ '<span class="ico">📐</span><span class="kop">' + tk('ph_weet_niet', 'Ik weet het niet') + '</span>'
				+ '<span class="sub">' + tk('ph_weet_niet_sub', 'Vul je opening in, wij kiezen mee') + '</span></button>';
			h += '</div><div id="bb-ph-meten"></div>'
				+ '<p class="bb-ph-uitleg">' + tk('ph_stap3_uitleg', '<b>Hoe kies je de maat?</b> De diameter is de dikte van de borstel. '
				+ 'Meet de opening tussen je dakpannen en de onderkant van je zonnepaneel, op het smalste punt. '
				+ 'Kies de borstel die die opening opvult: hij hoort licht te klemmen, zodat er geen vogel meer onderdoor kan '
				+ 'terwijl de lucht onder je panelen kan blijven stromen. Twijfel je tussen twee maten, neem dan de grootste: '
				+ 'een te dunne borstel laat vogels alsnog door.') + '</p>';

			toon(vStap3, h);
			tegelsAan(wortelEl.querySelector('#bb-ph-dtegels'), function (knop) {
				var d = parseInt(knop.getAttribute('data-diameter'), 10);
				if (d > 0) {
					wortelEl.querySelector('#bb-ph-meten').innerHTML = '';
					keuze.diameter = d;
					toonUitslag();
					naar(vUitslag);
				} else {
					keuze.diameter = 0;
					vUitslag.innerHTML = '';
					toonMeten();
				}
			});
			naar(vStap3);
		}

		/* Het hulpje voor wie de maat niet weet: opening invullen, wij noemen de
		   kleinste borstel die die opening dekt. */
		function toonMeten() {
			var vak = wortelEl.querySelector('#bb-ph-meten');
			vak.innerHTML = '<div class="bb-ph-velden">'
				+ '<label class="bb-ph-veld"><span>' + tk('ph_opening_label', 'Opening tussen dakpan en paneel (cm)') + '</span>'
				+ '<input type="number" id="bb-ph-opening" min="1" max="40" step="0.5" inputmode="decimal" placeholder="' + esc(tk('bijv_13', 'bijv. 13')) + '"></label>'
				+ '</div><p><button type="button" class="bb-ph-knop" id="bb-ph-adviesknop">' + tk('ph_adviseer', 'Adviseer een maat') + '</button></p>'
				+ '<div id="bb-ph-openingadvies"></div>';

			wortelEl.querySelector('#bb-ph-adviesknop').addEventListener('click', function () {
				var opening = leesGetal(wortelEl.querySelector('#bb-ph-opening'));
				var advies = wortelEl.querySelector('#bb-ph-openingadvies');
				if (opening <= 0) {
					advies.innerHTML = '<span class="bb-ph-fout" role="alert">' + tk('ph_fout_opening', 'Vul eerst je opening in centimeters in.') + '</span>';
					return;
				}
				var ds = K.diameters(G.producten);
				var passend = K.passendeDiameter(G.producten, opening);

				if (passend === null) {
					advies.innerHTML = '<div class="bb-ph-melding">' + tk('ph_te_groot', 'Een opening van {opening} cm is groter dan onze dikste borstel (Ø{max} cm). Neem even contact op, dan kijken we samen wat er wel kan.',
						{ opening: esc(K.getal(opening)), max: esc(ds[ds.length - 1]) }) + '</div>';
					return;
				}
				advies.innerHTML = '<div class="bb-ph-melding">' + tk('ph_past', 'Bij een opening van <b>{opening} cm</b> is <b>Ø{d} cm</b> de eerste maat die dat opvult. We rekenen het pakket daar meteen voor uit.',
					{ opening: esc(K.getal(opening)), d: esc(passend) }) + '</div>';
				keuze.diameter = passend;
				toonUitslag();
				naar(vUitslag);
			});
		}

		/* ---------- pre-order: voorraad naast de rekenkern ---------- */

		/** Getal zonder duizendpunt: parseInt in bs-preorder.js maakt van
		    "1.200" anders 1. Dus 1200 en 23,1. Afronden op twee decimalen, want
		    metMarge() geeft een echt kommagetal: gemeten kwam er anders
		    "1500,8400000000001 meter gevraagd" in de mail. */
		function poGetalPlat(n) {
			return String(Math.round((Number(n) || 0) * 100) / 100).replace('.', ',');
		}

		/** De regeltekst voor contact[Pakket], zoals in het pre-ordercontract. */
		function poPakketTekst(pakket, nodigMeters) {
			var stukken = pakket.regels.map(function (r) {
				return r.aantal + 'x Ø' + keuze.diameter + ' cm, ' + K.getal(r.product.meters) + ' meter'
					+ (r.product.sku ? ' (' + r.product.sku + ')' : '');
			});
			return stukken.join('; ') + '; ' + poGetalPlat(nodigMeters) + ' meter gevraagd';
		}

		/** Een keer /cart.js lezen, zodat "nog X op voorraad" klopt met wat de
		    klant al in zijn wagen heeft liggen. Mislukt het, dan rekenen we
		    verder met een lege wagen: liever iets te ruim dan onterecht
		    blokkeren, de 422-vangnet vangt de rest. */
		function poWagenLezen() {
			if (poWagenGevraagd || !W || !W.winkelwagenLezen) { return; }
			poWagenGevraagd = true;
			W.winkelwagenLezen().then(function (w) {
				poWagen = w;
				if (keuze.diameter > 0) { toonUitslag(); }
			}).catch(function () { poWagen = null; });
		}

		/** Melding M5 als het pakket niet in de voorraad past, anders ''. */
		function poPakketMelding(pakket, nodigMeters) {
			poVrij = null;
			poOpen = null;
			var po = global.BSPreorder;
			if (!po || !po.meldingHtml) { return ''; }
			var regels = pakket.regels.map(function (r) {
				return { variantId: r.product.id, aantal: r.aantal };
			});
			var u = po.controleerPakket(regels, poWagen);
			if (u.soort === 'ok' || !u.eerste) { return ''; }
			poVrij = u.eerste.vrij;
			poOpen = {
				regels: regels,
				meters: poGetalPlat(nodigMeters),
				diameter: keuze.diameter,
				pakket: poPakketTekst(pakket, nodigMeters),
				bron: 'Paneelhulp'
			};
			return po.meldingHtml('pakket', {
				variantId: u.eerste.variantId,
				opVoorraad: u.eerste.vrij,
				pakket: poPakketTekst(pakket, nodigMeters),
				meters: poGetalPlat(nodigMeters),
				diameter: keuze.diameter,
				bron: 'Paneelhulp'
			});
		}

		/** Melding M6 als er voor deze diameter helemaal niets leverbaar is. */
		function poLeegMelding(nodigMeters) {
			var po = global.BSPreorder;
			if (!po || !po.meldingHtml || !(keuze.diameter > 0) || !(nodigMeters > 0)) { return ''; }
			return po.meldingHtml('leeg', {
				diameter: keuze.diameter,
				meters: poGetalPlat(nodigMeters),
				bron: 'Paneelhulp'
			});
		}

		/** De knop komt van het gedeelde component en opent de dialoog via
		    gebeurtenisdelegatie op data-attributen. Een data-attribuut kan geen
		    lijst dragen, dus bij een pakket openen we hem zelf met
		    BSPreorder.open: dan staat in de dialoog ook op het scherm welk
		    pakket de klant aanvraagt en komt de voorraad per maat in de mail.
		    Bij een lege diameter zijn er geen regels; daar vullen we alleen de
		    ontbrekende gegevens aan. */
		function poKnopAanvullen(nodigMeters) {
			var po = global.BSPreorder;
			var knop = vUitslag.querySelector('[data-bs-po-open]');
			if (!po || !knop) { return; }

			if (poOpen && po.open) {
				var opties = poOpen;
				knop.removeAttribute('data-bs-po-open');
				knop.addEventListener('click', function () {
					if (!po.open(opties)) { global.location.href = (W ? W.wortel() : '/') + 'pages/contact'; }
				});
				return;
			}
			if (poVrij !== null) { knop.setAttribute('data-voorraad', poVrij); }
			if (!knop.getAttribute('data-pakket')) {
				knop.setAttribute('data-maat', 'Ø' + keuze.diameter + ' cm');
				knop.setAttribute('data-pakket', poGetalPlat(nodigMeters) + ' meter Ø' + keuze.diameter + ' cm gevraagd');
			}
		}

		/* ---------- de eindbeoordeling ---------- */

		function toonUitslag() {
			poWagenLezen();
			var lijst = K.vanDiameter(G.producten, keuze.diameter);
			var kaal = K.totaalKaal(groepen);
			var totaal = K.metMarge(kaal, marge);

			if (!lijst.length) {
				var leeg = poLeegMelding(totaal);
				vUitslag.innerHTML = leeg
					? '<h3>' + tk('dit_heb_je_nodig', 'Dit heb je nodig') + '</h3>' + leeg
					: '<div class="bb-ph-melding">' + tk('ph_niets', 'Voor Ø{d} cm hebben we op dit moment niets staan.', { d: esc(keuze.diameter) }) + '</div>';
				if (leeg) { poVrij = null; poOpen = null; poKnopAanvullen(totaal); }
				return;
			}

			if (totaal <= 0) { vUitslag.innerHTML = ''; return; }

			/* Dezelfde bovengrens als bij stap 2. Die knop is niet de enige weg
			   hiernaartoe: staat de uitslag eenmaal op het scherm, dan rekent
			   ververs() hem bij elke wijziging in stap 1 opnieuw uit, zonder nog
			   langs stap 2 te komen. Zonder deze regel rekent de hulp daar rustig
			   duizenden rollen uit. */
			if (totaal > I.maxMeters) {
				vUitslag.innerHTML = '<div class="bb-ph-melding">'
					+ tk('ph_teveel', 'Dat is meer dan {max} meter. Neem even contact op, dan maken wij een offerte op maat.', { max: I.maxMeters }) + '</div>';
				return;
			}

			var perRol = K.metersPerRol(G.producten, keuze.diameter);
			var nodigRollen = K.rollenNodig(totaal, perRol);
			var pakket = K.goedkoopstePakket(lijst, nodigRollen);
			if (!pakket) { return; }
			laatstePakket = pakket;

			var h = '<h3>' + tk('dit_heb_je_nodig', 'Dit heb je nodig') + '</h3>';

			// Per vlak uitgesplitst, zodat de klant het kan narekenen.
			h += '<div class="bb-ph-narekenen"><div class="kop">' + tk('ph_zo_komen', 'Zo komen we aan je meters') + '</div><ul class="bb-ph-lijst">';
			groepen.forEach(function (g, i) {
				if (!K.vlakGeldig(g)) { return; }
				var b = K.rijBreedte(g);
				var hh = K.rijHoogte(g);
				var perPaneel = g.ligging === 'staand' ? K.vlakKort(g) : K.vlakLang(g);
				var som;
				if (g.randen === 'omtrek') {
					som = '2 × (' + K.meterTekst(b) + ' + ' + K.meterTekst(hh) + ')';
				} else if (g.randen === 'onderboven') {
					som = '2 × ' + K.meterTekst(b);
				} else {
					som = K.meterTekst(b);
				}
				h += '<li><span>' + tk('ph_regel2', 'Vlak {n}: {aantal} × {per} {ligging}, {randen} → {som}',
					{ n: i + 1, aantal: g.aantal, per: esc(K.meterTekst(perPaneel)), ligging: esc(liggingTekst(g.ligging)), randen: esc(randTekst(g)), som: esc(som) }) + '</span>'
					+ '<b>' + esc(K.meterTekst(K.vlakMeters(g))) + '</b></li>';
			});
			h += '<li class="tussen"><span>' + tk('ph_samen', 'Samen') + '</span><b>' + esc(K.meterTekst(kaal)) + '</b></li>';
			if (marge.soort === 'procent' && marge.procent > 0) {
				h += '<li><span>' + tk('ph_marge_regel', 'Marge {pct}%', { pct: esc(K.procentTekst(marge.procent)) }) + '</span><b>+ ' + esc(K.meterTekst(totaal - kaal)) + '</b></li>';
			} else if (marge.soort === 'meters' && marge.meters > 0) {
				h += '<li><span>' + tk('ph_extra_meters', 'Extra meters') + '</span><b>+ ' + esc(K.meterTekst(marge.meters)) + '</b></li>';
			}
			h += '<li class="totaal"><span>' + tk('ph_totaal_nodig', 'Totaal nodig') + '</span><b>' + esc(K.meterTekst(totaal)) + '</b></li>';
			h += '</ul></div>';

			h += '<div class="bb-ph-rekensom">' + tk('ph_afgerond', '{m} afgerond op hele rollen van {per} m: <b>{rollen}</b> Ø{d} cm', {
				m: esc(K.meterTekst(totaal)),
				per: esc(K.getal(perRol)),
				rollen: nodigRollen + ' ' + (nodigRollen === 1 ? tk('rol_woord', 'rol') : tk('rollen_woord', 'rollen')),
				d: esc(keuze.diameter)
			}) + '</div>';

			h += pakketKaart(pakket, totaal);

			var lengtes = lijst.map(function (p) { return K.getal(p.meters) + ' m'; });
			h += '<p class="bb-ph-uitleg">' + tk('ph_combinaties', 'Wij hebben alle combinaties van {lengtes}'
				+ ' doorgerekend en tonen de goedkoopste. Een lange rol is per meter voordeliger dan hetzelfde aantal meters '
				+ 'in losse rollen, dus dat scheelt echt geld.', { lengtes: esc(lengtes.join(', ')) }) + '</p>';

			vUitslag.innerHTML = h;
			poKnopAanvullen(totaal);
			koppelKoopknop();
		}

		function pakketKaart(pakket, nodigMeters) {
			var stukken = pakket.regels.map(function (r) { return r.aantal + '× ' + K.getal(r.product.meters) + ' m'; });
			var over = pakket.meters - nodigMeters;

			var h = '<div class="bb-ph-kaart beste">';
			h += '<div class="kop">' + tk('ph_voordeligste', 'Voordeligste pakket') + '</div>';
			h += '<div class="som">' + esc(stukken.join(' + ')) + ' = <b>' + esc(K.meterTekst(pakket.meters)) + '</b></div>';

			h += '<ul class="regels">';
			pakket.regels.forEach(function (r) {
				var vanTekst = (r.product.vancenten > r.product.centen)
					? '<s>' + prijs(r.product.vancenten * r.aantal) + '</s> '
					: '';
				h += '<li><span class="aantal">' + r.aantal + '×</span> '
					+ '<a href="' + esc(r.product.url) + '">' + esc(r.product.naam) + '</a>'
					+ '<span class="prijs">' + vanTekst + prijs(r.product.centen * r.aantal) + '</span></li>';
			});
			h += '</ul>';

			var pakketExcl = pakket.regels.reduce(function (som, r) {
				return som + exclCenten(r.product.centen * r.aantal);
			}, 0);
			h += '<div class="totaal"><span>' + tk('totaal', 'Totaal') + '</span><b>' + prijsTwee(pakket.centen, pakketExcl) + '</b></div>';
			h += '<div class="klein">' + prijs(Math.round(pakket.centen / pakket.meters)) + ' ' + tk('per_meter', 'per meter')
				+ (over > 0.001 ? ' · ' + tk('ph_over', 'je houdt {m} over', { m: esc(K.meterTekst(over)) }) : ' · ' + tk('ph_precies', 'precies genoeg, niets over')) + '</div>';

			h += palletRegel(pakket);

			/* WooCommerce had hier een formulier met een nonce dat server-side werd
			   afgehandeld. Op Shopify is het een gewone knop die /cart/add.js
			   aanroept: geen nonce, geen sessiekoekje vooraf, geen server-side
			   controle op koopbare artikelen. Shopify weigert die zelf.

			   Past het pakket niet in de voorraad, dan staat op die plek de
			   pre-ordermelding: een koopknop die gegarandeerd een 422 oplevert
			   helpt niemand. */
			var poMelding = poPakketMelding(pakket, nodigMeters);
			h += '<div class="bb-ph-koop">'
				+ (poMelding
					? poMelding
					: '<button type="button" class="bb-ph-knop groot" id="bb-ph-koopknop">' + tk('ph_koopknop', 'Zet dit pakket in mijn winkelwagen') + '</button>')
				+ '<div id="bb-ph-koopmelding" role="status" aria-live="polite"></div>'
				+ '</div>';

			h += '</div>';
			return h;
		}

		/* ---------- de grens van 50 per regel (gemeten 16-09) ----------
		 *
		 * /cart/add.js kapt in de items[]-vorm ELKE regel af op 50 stuks, ook
		 * als er 871 op voorraad liggen. Gemeten in het werkthema:
		 *
		 *   items[] 1 regel 60          -> 422, 50 in de wagen
		 *   items[] 3 regels 50/50/50   -> 200, 150 in de wagen   (dus per regel)
		 *   items[] 50, daarna items 10 -> 422 "De maximale hoeveelheid van dit
		 *                                  artikel zit al in je winkelwagen"
		 *   /cart/change.js naar 120    -> 422, blijft op 50
		 *   enkele vorm {id, quantity}  -> 200, 120 in de wagen
		 *
		 * In porties van 50 opknippen helpt dus NIET: staat de regel eenmaal op
		 * 50, dan weigert de items[]-vorm de rest. De enkele vorm kent de grens
		 * niet en telt op bij wat er al ligt. bb-winkelwagen.js bouwt alleen de
		 * items[]-vorm en blijft ongemoeid, dus dit hoort hier thuis.
		 */
		var REGEL_MAX = 50;

		function perVariant(wagenJson) {
			var uit = {};
			((wagenJson && wagenJson.items) || []).forEach(function (r) {
				var k = String(r.id);
				uit[k] = (uit[k] || 0) + (r.quantity || 0);
			});
			return uit;
		}

		function wensenVan(pakket) {
			return (pakket.regels || []).map(function (r) {
				return { variantId: String(r.product.variant_id || r.product.id), aantal: r.aantal };
			});
		}

		function lees() {
			return W.winkelwagenLezen().catch(function () { return null; });
		}

		/** Een regel los toevoegen met de ENKELE vorm; die kent de grens van 50 niet. */
		function regelToevoegen(variantId, aantal) {
			return global.fetch(W.wortel() + 'cart/add.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
				credentials: 'same-origin',
				body: JSON.stringify({ id: variantId, quantity: aantal })
			}).then(function (a) {
				return a.json().catch(function () { return {}; }).then(function (j) {
					if (!a.ok) {
						var f = new Error(j.description || j.message || ('cart/add.js gaf ' + a.status));
						f.status = a.status;
						f.uitlegVanShopify = j.description || j.message || '';
						throw f;
					}
					return j;
				});
			});
		}

		/** Regel voor regel, achter elkaar. Een fout stopt de rij niet. */
		function zelfToevoegen(regels) {
			var fout = null;
			return regels.reduce(function (ketting, r) {
				return ketting.then(function () {
					return regelToevoegen(r.variantId, r.aantal).catch(function (e) { fout = fout || e; });
				});
			}, Promise.resolve()).then(function () { return fout; });
		}

		/** Het verschil tussen de wens en wat er sinds 'voor' echt bij kwam. */
		function nogNodig(wensen, voor, nu) {
			var a = perVariant(voor), b = perVariant(nu);
			return wensen.map(function (w) {
				var geleverd = (b[w.variantId] || 0) - (a[w.variantId] || 0);
				return { variantId: w.variantId, aantal: Math.max(0, w.aantal - geleverd) };
			}).filter(function (w) { return w.aantal > 0; });
		}

		function verslag(wensen, voor, nu, fout) {
			var a = perVariant(voor), b = perVariant(nu);
			var toegevoegd = 0, tekort = 0;
			wensen.forEach(function (w) {
				var geleverd = Math.max(0, Math.min(w.aantal, (b[w.variantId] || 0) - (a[w.variantId] || 0)));
				toegevoegd += geleverd;
				tekort += w.aantal - geleverd;
			});
			return {
				gelukt: tekort === 0, toegevoegd: toegevoegd, tekort: tekort,
				fout: tekort > 0 ? (fout || null) : null, antwoord: nu
			};
		}

		/**
		 * Het pakket in de winkelwagen, met de belofte van de knop overeind.
		 * Blijft elke regel binnen de 50, dan gaat het precies als voorheen: een
		 * verzoek via BBWinkel, alles of niets. Anders liefst het gedeelde
		 * global.BSPreorder.voegToe, en daarna meten we in /cart.js na wat er
		 * echt ligt en vullen we een tekort zelf aan. Nameten kan niet te veel
		 * toevoegen: er gaat alleen het GEMETEN verschil achteraan.
		 *
		 * @returns {Promise<{gelukt, toegevoegd, tekort, fout, antwoord}>}
		 */
		function pakketInWagen(pakket, secties) {
			var wensen = wensenVan(pakket);
			return lees().then(function (voor) {
				var al = perVariant(voor);
				var past = wensen.every(function (w) {
					return (al[w.variantId] || 0) + w.aantal <= REGEL_MAX;
				});
				if (past) {
					return W.pakketToevoegen(pakket, secties).then(function (u) {
						return { gelukt: true, toegevoegd: u.aantalArtikelen, tekort: 0, fout: null, antwoord: u.antwoord };
					});
				}

				var po = global.BSPreorder;
				var ronde1 = (po && typeof po.voegToe === 'function')
					? Promise.resolve().then(function () { return po.voegToe(wensen); })
						.then(function (u) { return (u && u.fout) || null; }, function (e) { return e; })
					: zelfToevoegen(wensen);

				return ronde1.then(function (fout1) {
					return lees().then(function (na1) {
						var rest = nogNodig(wensen, voor, na1);
						if (!rest.length) { return verslag(wensen, voor, na1, null); }
						return zelfToevoegen(rest).then(function (fout2) {
							return lees().then(function (na2) {
								return verslag(wensen, voor, na2, fout2 || fout1);
							});
						});
					});
				});
			});
		}

		function koppelKoopknop() {
			var knop = wortelEl.querySelector('#bb-ph-koopknop');
			if (!knop) { return; }
			knop.addEventListener('click', function () {
				if (!laatstePakket || !W) { return; }
				var melding = wortelEl.querySelector('#bb-ph-koopmelding');
				knop.disabled = true;
				if (melding) { melding.innerHTML = '<div class="bb-ph-melding">' + esc(TEKST_WINKELWAGEN.bezig) + '</div>'; }

				pakketInWagen(laatstePakket, I.winkelwagenSecties).then(function (uit) {
					/* Het thema wil de winkelwageninhoud zelf horen, dus gaat
					   uit.antwoord mee en niet het omhulsel eromheen. */
					if (uit.toegevoegd > 0) { W.meldWijziging(uit.antwoord); }
					if (!uit.gelukt) { return tekortTonen(knop, melding, uit); }

					if (I.naToevoegen === 'winkelwagen') {
						global.location.href = W.wortel() + 'cart';
						return;
					}
					knop.disabled = false;
					if (melding) {
						melding.innerHTML = '<div class="bb-ph-melding">' + esc(TEKST_WINKELWAGEN.gelukt)
							+ ' <a href="' + esc(W.wortel() + 'cart') + '">' + tk('ph_naar_wagen', 'Naar mijn winkelwagen') + '</a></div>';
					}
					/* De palletstand hangt aan wat er in de wagen ligt, en dat is
					   net veranderd. Opnieuw ophalen en de uitslag bijwerken. */
					haalWinkelwagen();
				}).catch(function (f) {
					/* Alleen nog netwerkfouten en de alles-of-niets-422 van
					   BBWinkel: dan ligt er niets extra in de wagen. */
					tekortTonen(knop, melding, { toegevoegd: 0, tekort: 0, fout: f });
				});
			});
		}

		/**
		 * Er is niets of maar een deel toegevoegd. Verse voorraad halen en
		 * opnieuw tekenen, zodat de klant M5 met de pre-orderknop ziet in plaats
		 * van alleen een rode regel. Komt er geen melding uit, dan blijft de
		 * rode regel staan.
		 */
		function tekortTonen(knop, melding, uit) {
			knop.disabled = false;
			var f = uit.fout;
			var tekst = uit.toegevoegd > 0
				? TEKST_WINKELWAGEN.deels
				: ((!f || f.status === 422) ? TEKST_WINKELWAGEN.mislukt : TEKST_WINKELWAGEN.verbinding);
			if (melding) {
				melding.innerHTML = '<span class="bb-ph-fout" role="alert">' + esc(tekst) + '</span>';
			}
			if (f && f.uitlegVanShopify && global.console) {
				global.console.warn('[bb-paneelhulp] cart/add.js: ' + f.uitlegVanShopify);
			}

			var po = global.BSPreorder;
			if (!po || !po.ververs) { return; }
			po.ververs().catch(function () { return false; }).then(function () {
				haalWinkelwagen();
				toonUitslag();
				var opnieuw = wortelEl.querySelector('#bb-ph-koopmelding');
				if (opnieuw && !vUitslag.querySelector('[data-bs-po-open]')) {
					opnieuw.innerHTML = '<span class="bb-ph-fout" role="alert">' + esc(tekst) + '</span>';
				}
			});
		}

		/* ---------- de palletregel ---------- */

		/**
		 * DE SCHAKELAAR. Zolang de palletkorting niet echt in de winkelwagen
		 * valt, staat deze regel niet op de kaart. Een thema kan de
		 * winkelwagentotalen niet aanpassen; dat kan alleen een eigen app met een
		 * Shopify Function. Zonder die Function zou de kaart 5 procent beloven en
		 * de winkelwagen 0 procent rekenen, en dat merkt niemand tot een klant
		 * belt. Zet hem dus pas aan als de korting bewezen valt.
		 */
		function palletRegel(pakket) {
			if (!I.toonPalletregel) { return ''; }

			var stand = K.palletStand(G, keuze.diameter, pakket);
			if (!stand) { return ''; }

			var wagenTekst = stand.alInWagen > 0
				? ' (' + (stand.alInWagen === 1
					? tk('ph_incl_een', 'inclusief de {n} rol die al in je winkelwagen ligt', { n: stand.alInWagen })
					: tk('ph_incl', 'inclusief de {n} rollen die al in je winkelwagen liggen', { n: stand.alInWagen })) + ')'
				: '';

			if (stand.percentage > 0) {
				return '<div class="bb-ph-pallet klaar">🎉 ' + tk('ph_pallet_klaar', 'Dit is <b>{deel} pallet</b>{wagen}. '
					+ 'Je krijgt <b>{pct}% palletkorting</b>: dat scheelt ongeveer <b>{bedrag}</b> op dit pakket. De winkelwagen rekent het exacte bedrag uit.',
					{ deel: esc(K.getal(stand.deel)), wagen: esc(wagenTekst), pct: esc(K.getal(stand.percentage, 0)), bedrag: prijs(stand.geschatteKortingCenten) }) + '</div>';
			}

			return '<div class="bb-ph-pallet">📦 ' + tk('ph_pallet_nog', 'Dit pakket is <b>{deel} pallet</b>{wagen}. '
				+ 'Nog <b>{rollen}</b> van deze maat erbij en je krijgt '
				+ '<b>{pct}% palletkorting</b> over je hele bestelling.', {
				deel: esc(K.getal(stand.deel)),
				wagen: esc(wagenTekst),
				rollen: stand.rollenTotEersteTrede + ' ' + (stand.rollenTotEersteTrede === 1 ? tk('rol_woord', 'rol') : tk('rollen_woord', 'rollen')),
				pct: esc(K.getal(G.treden.een, 0))
			}) + '</div>';
		}

		/**
		 * Wat er al in de winkelwagen ligt komt NA de eerste tekening binnen:
		 * Shopify kan de pagina gecachet uitserveren, dus /cart.js is de enige
		 * betrouwbare bron. Tot dat verzoek terug is telt de wagen als leeg, en
		 * dat is beter dan een getal tonen dat straks verspringt.
		 *
		 * Zonder palletregel hoeft dit verzoek helemaal niet: dan gebruikt niets
		 * op het scherm dit getal.
		 */
		function haalWinkelwagen() {
			if (!I.toonPalletregel || !W) { return; }
			W.rollenInWinkelwagen(G.producten).then(function (rollen) {
				G.winkelwagen = rollen;
				if (keuze.diameter > 0) { toonUitslag(); }
			});
		}

		/* ---------- starten ---------- */

		groepen.push(nieuwVlak());
		tekenGroepen();
		haalWinkelwagen();

		return {
			groepen: groepen,
			marge: marge,
			keuze: keuze,
			ververs: ververs,
			instellingen: I
		};
	}

	/* ======================================================================
	 * VANZELF STARTEN
	 * ----------------------------------------------------------------------
	 * Alleen als de section echt op de pagina staat. Zo kan dit bestand ook in
	 * node ingeladen worden om de tekening na te rekenen, zonder browser.
	 * ==================================================================== */
	function autoStart() {
		var doc = global.document;
		if (!doc) { return; }
		Array.prototype.forEach.call(doc.querySelectorAll('[data-bb-paneelhulp]'), function (el) {
			if (el.getAttribute('data-bb-gestart') === '1') { return; }
			el.setAttribute('data-bb-gestart', '1');

			var G = W && W.leesGegevens(el.getAttribute('data-bb-gegevens') || 'bb-rekendata');
			if (!G) {
				el.innerHTML = '<div class="bb-ph-melding">' + tk('ph_geen_rollen', 'De rekenhulp kan de rollen niet vinden. '
					+ 'Controleer of de collectie in de thema-instellingen klopt en of de velden diameter, meters en rollen gevuld zijn.') + '</div>';
				return;
			}

			var instellingen = {};
			try {
				var blok = doc.getElementById(el.getAttribute('data-bb-instellingen') || 'bb-ph-instellingen');
				if (blok) { instellingen = JSON.parse(blok.textContent || '{}'); }
			} catch (e) { /* terugval op STANDAARD */ }

			start(el, G, instellingen);
		});
	}

	if (global.document) {
		if (global.document.readyState === 'loading') {
			global.document.addEventListener('DOMContentLoaded', autoStart);
		} else {
			autoStart();
		}
		/* De thema-editor bouwt een section opnieuw op zonder de pagina te
		   herladen. Zonder deze regel is de hulp na een instelwijziging dood. */
		global.document.addEventListener('shopify:section:load', autoStart);
	}

	global.BBPaneelhulp = {
		tekening: tekening,
		TEKENING: TEKENING,
		STANDAARD: STANDAARD,
		TEKST_WINKELWAGEN: TEKST_WINKELWAGEN,
		start: start,
		autoStart: autoStart
	};
}(typeof window !== 'undefined' ? window : globalThis));
